import { ComponentRef, InjectionToken, ViewContainerRef } from '@angular/core';


export const UserControlResolver = new InjectionToken('UserControlResolver');

export interface IUserControlResolver {
    loadComponent(vcr: ViewContainerRef, idUserControl: string | undefined): Promise<ComponentRef<any>>;
}
